import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface Toast {
  message: string;
  duration?: number; // in seconds
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  constructor(private snackBar: MatSnackBar) {}

  /**
   * Display a toast message to the user using MatSnackBar.
   * @param toast { message: string; duration?: number; }
   * duration is in seconds, defaults to 0.7s
   */
  showToast(toast: Toast) {
    this.snackBar.open(toast.message, undefined, {
      duration: (toast.duration ?? 0.9) * 1000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: ['cerberus-toast'],
    });
  }
}
